<template>
  <div class="slider-navigation">
    <fn-slider
      :options="{
        containerModifierClass: 'swiper-container-faded-',
        slidesPerView: 'auto',
        spaceBetween: 10,
        pagination: false,
        navigation: false,
        watchOverflow: true,
        centeredSlides: isCenteredSlide,
        initialSlide: isCenteredSlide ? indexActiveTab : 0,
      }"
      gradient-right
    >
      <fn-slide
        v-for="(node, index) in nodes"
        :key="node.id"
      >
        <fn-button
          :class="{
            'is-highlight': node?.variant === 'highlight',
            'nuxt-link-exact-active': isAccountLayout && indexActiveTab === index,
            'is-active': indexActiveTab === index,
          }"
          :icon="isAccountLayout && indexActiveTab === index ? 'circle-tick' : ''"
          :to="node.url"
          :hide-from-crawl="hideFromCrawl"
        >
          {{ node.title }}
        </fn-button>
      </fn-slide>
    </fn-slider>
  </div>
</template>

<script>
export default {
  props: {
    nodes: {
      type: Array,
      required: true,
    },
    centerAfterNodeIndex: {
      type: Number,
      default: 0,
    },
    isAccountLayout: {
      type: Boolean,
    },
    hideFromCrawl: {
      type: Boolean,
    },
  },

  computed: {
    indexActiveTab() {
      return this.nodes.findIndex((node) => {
        if (this.isAccountLayout && this.isOrdersPage) {
          return node.url.includes(this.$t('url.account.orders'));
        }

        // Adjust for "my products" sub-menu (wishlist & buy again)
        if (
          this.isAccountLayout &&
          node.url === this.$t('url.account.buyAgain') &&
          unref(useIsPageUrl('url.account.wishlist'))
        ) {
          return true;
        }

        return unref(useIsPageUrl(node.url, false));
      });
    },

    /**
     * Returns true if the current slide should be centered,
     * false if it should be aligned to the left of the slider
     * @returns {boolean}
     */
    isCenteredSlide() {
      const notStartNode = this.indexActiveTab > this.centerAfterNodeIndex;
      const notEndNode = this.indexActiveTab < this.nodes.length - 1;
      const hasMultipleNodes = this.nodes.length > 1;

      return hasMultipleNodes && notStartNode && notEndNode;
    },
    isOrdersPage() {
      return this.$route.fullPath.includes(this.$t('url.account.orders'));
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  box-sizing: border-box;

  &.nuxt-link-exact-active,
  &.router-link-exact-active {
    background-color: $color-brand-fnmz-green;
    border-color: $color-brand-fnmz-green;
    font-weight: map-get($font-weights, 'bold');
    color: $color-general-text-inverse-default;
  }

  &.nuxt-link-exact-active,
  &.is-active {
    background-color: $color-action-background-primary-default-press;

    &:focus,
    &:active {
      color: $color-general-text-inverse-default;
    }
  }

  &.is-highlight {
    background-color: palette(happyColor, orange);
    border: none;
    color: $color-general-text-inverse-default;
    font-weight: map-get($font-weights, 'bold');
  }
}
</style>
